import { render, staticRenderFns } from "./VatExpenseReportPrintDownload.vue?vue&type=template&id=2cb9054f&"
import script from "./VatExpenseReportPrintDownload.vue?vue&type=script&lang=js&"
export * from "./VatExpenseReportPrintDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports